import React, { Component } from 'react'
import './index.css'
import { BsyUtils } from "../../utils/Utils";
import BsyTableList from "../BsyTableList";
import LoginAccountInput from "../../Login/LoginAccountInput";
import BsyIconBtn from "../BsyIconBtn";
import BsyDomTree from '../BsyDomTree';
import emptyDockUser from "../../images/img_wudaiban@2x.png";
import tipAlert from "../../Login/BsyAlertTip/Staticize";
import BsyAlert from "../BsyAlert";
import CorpCoopRolePane from './CorpCoopRolePane';
import CorpDeptUserPane from './CorpDeptUserPane';
import BsyAlertMenu from "../BsyAlertMenu";
import BsyAlertListDetail from '../BsyAlertListDetail';
import BsyAlertInviteUser from '../BsyAlertInviteUser';


class CorpCoopDeatilsPane extends Component {
    static defaultProps = {
        item: {},
        corpCoopMap:{},
        contactMap:{},
        labelId: [],
        corpCoopList:[],
        owner_coprs:[],
        isOther:false,
        corpUserType: "other",
        emailCodeLogin: true,
        mobileCodeLogin: true,
    }
    constructor(props) {
        super(props);
        this.state = {
            item: props.item,
            corpCoopMap:props.corpCoopMap,
            contactMap:props.contactMap,
            corpCoopList: props.corpCoopList,
            corpUserType:props.corpUserType,
            selectType: props.selectType,
            selectGroup: props.selectGroup,
            labelId: props.labelId,
            isOther: props.isOther,
            owner_coprs: props.owner_coprs,
            emailCodeLogin: props.emailCodeLogin,
            mobileCodeLogin: props.mobileCodeLogin,
            nameWidth: 0,
        }
        this.nameWidthEl = React.createRef();
    }

    componentDidMount(){
        this.nameWidthEl.current && this.setState({nameWidth: this.nameWidthEl.current.offsetWidth + 4})
    }

    closeAlert = () =>{
        this.props.newProps && this.props.newProps.props &&  this.props.newProps.props.onRemoveRoot && this.props.newProps.props.onRemoveRoot();
    }

    changeDockCorpName = (e) =>{
        const { item } = this.state;
        let name = e.target.value;
        item.dock_corpname = name;
        this.setState({item},()=>{
            this.nameWidthEl.current && this.setState({
                nameWidth: this.nameWidthEl.current.offsetWidth + 4
            },()=>{
                this.props.onChangeDockCorpName && this.props.onChangeDockCorpName(item)
            })
        })
        
    }

    onChangeDockCorpName = (val) =>{

    }

    blurDockCorpName = () =>{
        const { item } = this.state;
        React.axios("/corp/dock/corp/update",{
            dock_corpid: item.dock_corpid,
            name: item.dock_corpname
        }).then(res=>{
            if(res.data.errcode !== 0){
                tipAlert({
                    type: 'warning',
                    msg: res.data.errmessage
                })
                return
            }
            this.props.RefreshList && this.props.RefreshList()
        })
    }

    handleUserOrder = () =>{

    }

    againAllInvite = () =>{

    }

    memberUpdate = (data) => {
        const { item } = this.state;
        console.log(data)
        // React.axios("/corp/dock/corp/update",{
        //     dock_corpid: item.dock_corpid,
        //     name: item.dock_corpname
        // }).then(res=>{
        //     if(res.data.errcode !== 0){
        //         tipAlert({
        //             type: 'warning',
        //             msg: res.data.errmessage
        //         })
        //         return
        //     }
        //     this.props.RefreshList && this.props.RefreshList()
        // })
    }

    removeCorpRole = (item) =>{
        let items = this.state.item;
        let corpUserData = this.state.item.dock_user || [];
        let newUserList = [];
        corpUserData.map(res=>{
            if(res.user_id !== item.user_id){
                newUserList.push({
                    ...res
                })
            }
        });
        items.dock_user = newUserList;
        this.setState({item: items})
    }

    memberRowClick = (event, item) =>{
        const {selectGroup, corpCoopMap, contactMap, selectType, corpCoopList, corpUserType, owner_coprs, isOther, emailCodeLogin, mobileCodeLogin} = this.state;
        
        if (event.target.classList[0] === "icon-flow-other" || event.target.classList[0] === "menuTd") {
            let menu = [{
                text: React.language('edit'),
                colorType: "",
                click: () => {
                    BsyAlertListDetail({
                        type: "custom",
                        width: 400,
                        clsName: "BsyAlertCorpCoopRolePane",
                        createContent:(e)=>{
                            return <CorpCoopRolePane owner_coprs={owner_coprs}emailCodeLogin={emailCodeLogin} mobileCodeLogin={mobileCodeLogin} RefreshList={this.props.RefreshList} newProps={e} item={item} corpCoopMap={corpCoopMap} contactMap={contactMap} selectGroup={selectGroup} selectType={selectType} changeDockCorp={this.changeDockCorp} onChangeDockCorpName={this.onChangeDockCorpName} />
                        }
                    })
                }
            },{
                text: React.language('remove.out'),
                colorType: "red",
                click: () => {
                    BsyAlert({
                        title: React.language("contact.docker.remove.title"),
                        type: "warning",
                        msg: React.language("contact.docker.remove.tip"),
                        text4Ok: React.language("ok"),
                        OkType: "red",
                        text4Cancel: React.language("cancel"),
                        ok: () => {
                            React.axios("/corp/dock/member/delete",{corp_id: [item.owner_corpid], user_id: [item.user_id], type: "corp"}).then(res=>{
                                if(res.data.errcode !== 0){
                                    tipAlert({
                                        type: 'warning',
                                        msg: res.data.errmessage
                                    })
                                    return
                                }
                                if(res.data.errcode === 0){
                                    let items = this.state.item;
                                    let corpUserData = this.state.item.dock_user || [];
                                    let newUserList = [];
                                    corpUserData.map(res=>{
                                        if(res.user_id !== item.user_id){
                                            newUserList.push({
                                                ...res
                                            })
                                        }
                                    });
                                    items.dock_user = newUserList;
                                    this.setState({item: items})
                                }else{
                                    tipAlert({
                                        type: 'warning',
                                        msg: res.data.errmessage
                                    })
                                    return
                                }
                                this.props.RefreshList();
                            })
                        }
                    })
                }
            }];

            if(corpUserType === "current"){
                menu = [
                    {
                        text: React.language('remove.out'),
                        colorType: "red",
                        click: () => {
                            BsyAlert({
                                title: React.language("contact.docker.remove.title"),
                                type: "warning",
                                msg: React.language("contact.docker.remove.tip"),
                                text4Ok: React.language("ok"),
                                OkType: "red",
                                text4Cancel: React.language("cancel"),
                                ok: () => {
                                    React.axios("/corp/dock/member/remove",{corp_id: [item.dock_corpid], user_id: [item.user_id], mode: isOther ? "guest" : "host"}).then(res=>{
                                        if(res.data.errcode !== 0){
                                            tipAlert({
                                                type: 'warning',
                                                msg: res.data.errmessage
                                            })
                                            return
                                        }
                                        if(res.data.errcode === 0){
                                            let items = this.state.item;
                                            let corpUserData = this.state.item.user || [];
                                            let newUserList = [];
                                            corpUserData.map(res=>{
                                                if(res.user_id !== item.user_id){
                                                    newUserList.push({
                                                        ...res
                                                    })
                                                }
                                            });
                                            items.user = newUserList;
                                            this.setState({item: items})
                                        }
                                        
                                        this.props.RefreshList();
                                    })
                                }
                            })
                            
                        }
                    }
                ]
            }

            BsyAlertMenu({
                item: menu,
                // renderEl: event.currentTarget,
                width: 100,
                target: event.target
            })
        } else if (event.target.classList[1] === "again") {
            // const mobile = item.phone
            // if (!mobile) {
            //     tipAlert({
            //         type: "warning",
            //         msg: React.language("Invited.tip1")
            //     })
            //     return;
            // }
            this.againAllInvite(item._id)

        } else if (event.target.classList[0] === "removeout-text") {
            // const mobile = item.phone
            // if (!mobile) {
            //     tipAlert({
            //         type: "warning",
            //         msg: React.language("Invited.tip1")
            //     })
            //     return;
            // }
            BsyAlert({
                title: React.language("contact.docker.remove.title"),
                type: "warning",
                msg: React.language("contact.docker.remove.tip"),
                text4Ok: React.language("ok"),
                OkType: "red",
                text4Cancel: React.language("cancel"),
                ok: () => {
                    React.axios("/corp/dock/member/remove",{corp_id: [item.dock_corpid], user_id: [item.user_id], mode: isOther ? "guest" : "host"}).then(res=>{
                        if(res.data.errcode !== 0){
                            tipAlert({
                                type: 'warning',
                                msg: res.data.errmessage
                            })
                            return
                        }
                        if(res.data.errcode === 0){
                            let items = this.state.item;
                            let corpUserData = this.state.item.user || [];
                            let newUserList = [];
                            corpUserData.map(res=>{
                                if(res.user_id !== item.user_id){
                                    newUserList.push({
                                        ...res
                                    })
                                }
                            });
                            items.user = newUserList;
                            this.setState({item: items})
                        }
                        
                        this.props.RefreshList();
                    })
                }
            })

        } else {
            if(corpUserType === "current" || isOther){
                return
            }
            BsyAlertListDetail({
                type: "custom",
                width: 400,
                clsName: "BsyAlertCorpCoopRolePane",
                createContent:(e)=>{
                    return <CorpCoopRolePane removeCorpRole={this.removeCorpRole}emailCodeLogin={emailCodeLogin} mobileCodeLogin={mobileCodeLogin} owner_coprs={owner_coprs} RefreshList={this.props.RefreshList} newProps={e} item={item} corpCoopMap={corpCoopMap} contactMap={contactMap} selectGroup={selectGroup} selectType={selectType} changeDockCorp={this.changeDockCorp} onChangeDockCorpName={this.onChangeDockCorpName} />
                }
            })
        }
    }

    changeDockCorp = (v) =>{
        const {item, corpUserType} = this.state;
        console.log(v,item)
        let corpUserData = item.dock_user || [];
        if(corpUserType === "current"){
            corpUserData = item.user || [];
        }
        corpUserData.map(res=>{
            if(res._id === v._id){
                res = v;
            }
        })
        if(corpUserType === "current"){
            item.user = corpUserData;
        }else{
            item.dock_user = corpUserData;
        }
        this.setState({item: item})
    }

    getTableValue = (ref) =>{
        console.log(ref)
    }

    dockSwitch = (e) =>{
        return ()=>{
            this.setState({corpUserType: e})
        }
    }

    hoverAddPanel = (event) =>{
        const $ = window.$;
        const FX = window.FX;
        const _this = this;
        const {item, corpUserType} = this.state;
        if(!item.is_tmp_owner && (corpUserType === "other" || corpUserType === "otherDept")){
            _this.tipAdd && _this.tipAdd.close && _this.tipAdd.close();
            _this.tipAdd = FX.Msg.bubble({
                anchor: $(event.currentTarget),
                contentHTML: $("<div class='addDockBanTip' />").append($("<div class='banTip' />").text(item.common ? (corpUserType === "otherDept" ? React.language("corp.coop.dept.manage.apply.tip") : React.language("corp.coop.manage.apply.tip")) : React.language("corp.coop.manage.integrated.tip",{productName:window._bby_config.site_name})).append(item.common ? $("<button />").on("click",function(){
                    React.axios("/corp/apply_owner",{dock_corpid: item.dock_corpid}).then(res=>{
                        if(res.data.errcode !== 0){
                            tipAlert({
                                type: "warning",
                                msg: res.data.errmessage
                            })
                            return;
                        }
                        tipAlert({
                            type: "success",
                            msg: React.language('contact.manage.auth.request.success')
                        })
                    })
                }).append($("<span />").text(React.language("contact.manage.auth.request"))) : "")),
                text4Cancel: null,
                text4Ok: null,
                dockPosition: "left",
                hAdjust: event.currentTarget.offsetWidth / 2 - 8,
                minWidth: 400,
                contentPadding: 0,
                topOffset: 10,
                edge: 60
            })
            _this.tipAdd.element.mouseleave(() => {
                _this.tipAdd && _this.tipAdd.close && _this.tipAdd.close();
            })
        }
    }

    openAddPane = () =>{
        const {item, corpUserType} = this.state;
        if(corpUserType === "other" || corpUserType === "current"){
            if(corpUserType === "other" && !item.is_tmp_owner){
                return
            }
            this._createCorpUserBubble();
            // BsyAlertInviteUser({
            //     title: React.language('contact.handover.add'),
            //     styleCss: {
            //         width: 760,
            //         height: 540
            //     },
            //     departmentId: null,
            //     emailCodeLogin: this.emailCodeLogin,
            //     deptId: null,
            //     isAllDept: false,
            //     dock_corpid: item.dock_corpid,
            //     isOther: true,
            //     onRefresh: (res) => {
            //         let items = item;
            //         items.dock_user = res.data.user_list;
            //         this.setState({item: items},() =>{
            //             this.props.RefreshList();
            //         });
            //     },
            // })
            
        } else if (corpUserType === "currentDept" || corpUserType === "otherDept"){
            if(corpUserType === "otherDept" && !item.is_tmp_owner){
                return
            }
            this._createCorpDeptBubble();
        }
    }

    _createCorpDeptBubble = () =>{
        const { item, corpUserType } = this.state;
        const _this = this;
        const userItemList = (corpUserType === "otherDept" ? item.dock_dept : item.dept) || [];
        let userList = []
        userItemList.map(res=>(
            res.dept_id && userList.push(res.dept_id)
        ))
        var e = new window.FX.ConfirmDialog({
            title: React.language("widget.dept.listTitle"),
            height: 586,
            width: 956,
            contentWidget: {
                rowSize: [450],
                colSize: [926],
                padding: 15,
                items: [[{
                    widgetName: "memberSelect",
                    type: "memberselectpane",

                    hasMenuType:false,
                    hasDock: false,
                    editable: !0,
                    roleEnable: 0,
                    dock_corpid: corpUserType === "otherDept" ? item.dock_corpid : "",
                    memberEnable: !1,
                    departmentEnable: !0,
                    hasTeamManageBtn: !1,
                    outsiderMemberEnable: !1,
                    outsiderGroupEnable: !1,
                    value: userList,
                }]]
            },
            onOk: function () {
                let dept = e.getWidgetByName("memberSelect");
                let d1 = dept.getAllJsonValue();
                _this.editCorpDept(d1.departs, corpUserType === "otherDept");
                return !1
            }
        });
        e.show()
    }

    editCorpDept = (dept, u) =>{
        const {item, isOther} = this.state;
        React.axios("/corp/dock/dept/add",{
            dock_corpid: u ? item.dock_corpid : undefined,
            dept_id_list: dept,
            host_corp_id_list: !isOther ? [this.state.item.dock_corpid] : [],
            guest_corp_id_list: isOther ? [this.state.item.host_corpid] : [],
        }).then(res=>{
            let items = item;
            if(u){
                items.dock_dept = res.data.dept_list;
                this.domTreeContext && this.domTreeContext.updataTree && this.domTreeContext.updataTree(this.deepCopy(items.dock_dept));
            }else{
                items.dept = res.data.dept_list;
                this.domTreeContext1 && this.domTreeContext1.updataTree && this.domTreeContext1.updataTree(this.deepCopy(items.dept));
            }
            
            this.setState({item: items});
            this.props.RefreshList && this.props.RefreshList()
        })
    }

    _createCorpUserBubble = () =>{
        const { item, corpUserType } = this.state;
        const _this = this;
        const userItemList = (corpUserType === "other" ? item.dock_user : item.user) || [];
        let userList = userItemList.map(res=>{
            return res.user_id
        })
        var e = new window.FX.ConfirmDialog({
            title: React.language("widget.user.listTitle"),
            height: 586,
            width: 956,
            contentWidget: {
                rowSize: [450],
                colSize: [926],
                padding: 15,
                items: [[{
                    widgetName: "memberSelect",
                    type: "memberselectpane",

                    hasMenuType: !1,
                    hasDock: !1,
                    editable: !0,
                    roleEnable: 0,
                    dock_corpid: corpUserType === "other" ? item.dock_corpid : "",
                    departmentEnable: !1,
                    hasTeamManageBtn: !1,
                    outsiderMemberEnable: !1,
                    outsiderGroupEnable: !1,
                    value: userList,
                }]]
            },
            onOk: function () {
                let dept = e.getWidgetByName("memberSelect");
                let d1 = dept.getAllJsonValue();
                _this.editCorpUser(d1.users, corpUserType === "other");
                return !1
            }
        });
        e.show()
    }

    editCorpUser = (user, u) =>{
        const {item, isOther} = this.state;
        React.axios("/corp/dock/member/add",{
            dock_corpid: u ? item.dock_corpid : undefined,
            user_id_list: user,
            host_corp_id_list: !isOther ? [this.state.item.dock_corpid] : [],
            guest_corp_id_list: isOther ? [this.state.item.host_corpid] : [],
        }).then(res=>{
            let items = item;
            if(u){
                items.dock_user = res.data.user_list;
            }else{
                items.user = res.data.user_list;
            }
            this.setState({item: items});
            this.props.RefreshList && this.props.RefreshList()
        })
    }

    removeContact = () =>{
        const {selectType, selectGroup, item, isOther, newProps} = this.props;
        BsyAlert({
            title: React.language("contact.connection.remove.confirm.title"),
            type: "warning",
            msg: React.language("contact.connection.selected.remove.tip"),
            text4Ok: React.language("ok"),
            OkType: "red",
            text4Cancel: React.language("cancel"),
            ok: () => {
                if(isOther){
                    if(selectGroup === "corpCoopAll"){
                        React.axios("/corp/dock/corp/delete",{label_id: [], type: "guest_corp", dock_corpid: [item.host_corpid]}).then(res=>{
                            this.props.RefreshList();
                        })
                    }else{
                        React.axios("/corp/dock/corp/delete",{label_id: [selectGroup], type: "label", dock_corpid: [item.host_corpid]}).then(res=>{
                            this.props.RefreshList();
                        })
                    }
                }else{
                    if(selectGroup === "corpCoopAll"){
                        React.axios("/corp/dock/corp/delete",{label_id: [], type: "corp", dock_corpid: [item.dock_corpid]}).then(res=>{
                            this.props.RefreshList();
                        })
                    }else{
                        React.axios("/corp/dock/corp/delete",{label_id: [selectGroup], type: "label", dock_corpid: [item.dock_corpid]}).then(res=>{
                            this.props.RefreshList();
                        })
                    }
                }
                newProps && newProps.closeAlert && newProps.closeAlert();
                return true;
            }
        })
        
    }

    openLabelPane = () =>{
        let that = this;
        const { item, corpCoopList } = this.state;
        const depars = item.label_id ? [item.label_id] : [];
        const d = new window.FX.ConfirmDialog({
            title: React.language("member.select.list"),
            height: 576,
            width: 710,
            contentWidget: {
                rowSize: [440],
                colSize: [680],
                padding: 15,
                items: [[{
                    widgetName: "memberSelect",
                    type: "memberselectpane",

                    editable: !0,
                    checkEnable: !1,
                    hasMenuType:false,
                    departmentEnable: !1,
                    corpCoopLabelEnable: !0,
                    memberEnable: !1,
                    outsiderMemberEnable: !1,
                    outsiderGroupEnable: !1,
                    roleEnable: !1,
                    radioEnable: !0,
                    dynamicEnable: !1,
                    dynamicType: "set", 
                    checkType: 'radio',
                    items: corpCoopList,
                    value: depars,
                }]]
            },
            onOk: function () {
                var dept = d.getWidgetByName("memberSelect");
                var d1 = dept.getAllJsonValue();
                if (!d1) {
                    return;
                }

                let it = {...item}
                it.label_id = d1.labelCorpGroup[0];
                
                that.setState({
                    item: it
                }, () => {
                    // that.switchChange(true);
                    React.axios("/corp/dock/corp/update", {
                        label_id: d1.labelCorpGroup.length > 0 ? d1.labelCorpGroup[0] : "",
                        dock_corpid: [item.dock_corpid]
                    }).then(res=>{
                        if(res.data.errcode !== 0){
                            tipAlert({
                                type: 'warning',
                                msg: res.data.errmessage
                            })
                            return
                        }
                        that.props.RefreshList();
                    })
                })

                return !1;
            }
        });
        d.show()
    }

    openAuthTransfer = () =>{
        let that = this;
        const { item } = this.state;
        BsyAlert({
            title: React.language("contact.manage.auth.transfer.title"),
            type: "warning",
            OkType: "red",
            msg: React.language("contact.manage.auth.transfer.msg"),
            text4Ok: React.language("ok"),
            text4Cancel: React.language("cancel"),
            ok: () => {
                React.axios('/corp/transfer_owner', {
                    dock_corpid: item.dock_corpid,
                    owner_corpid: item.owner_corpid,
                }).then(res => {
                    // const { target } = this.props;
                    // target.parentNode.remove();
                    that.props.RefreshList();
                    tipAlert({
                        type: 'success',
                        msg: React.language('corp.coop.contact.request.success.title')
                    })
                    this.closeAlert()
                })
                return true;
            }
        })
    }

    addAgainUser = (item) =>{
        let that = this;
        React.axios('/corp/dock/member/reinvite', {
            dock_corpid: item.dock_corpid,
            memberIds: [item.user_id],
            role_id: [],
        }).then(res => {
            // const { target } = this.props;
            // target.parentNode.remove();
            tipAlert({
                type: 'success',
                msg: React.language('message.sended')
            })
            that.props.RefreshList();
        })
    }

    addAgainAllUser = () =>{
        let that = this;
        const {item} = this.state;
        React.axios('/corp/dock/member/reinvite', {
            dock_corpid: item.dock_corpid,
            memberIds:[],
            role_id: [],
        }).then(res => {
            // const { target } = this.props;
            // target.parentNode.remove();
            tipAlert({
                type: 'success',
                msg: React.language('message.sended')
            })
            that.props.RefreshList();
        })
    }

    openDockCorpInvite = () =>{
        let that = this;
        const { item } = this.state;
        React.axios('/corp/dock/corp/invite', {
            dock_corpid: item.host_corpid,
            dock_corpname: item.host_corpname,
        }).then(res => {
            // const { target } = this.props;
            // target.parentNode.remove();
            tipAlert({
                type: 'success',
                msg: React.language('message.sended')
            })
            that.props.RefreshList();
        })
        // BsyAlert({
        //     title: React.language("consolidate.departments.groups.title"),
        //     type: "warning",
        //     OkType: "blue",
        //     text4Ok: React.language("ok"),
        //     text4Cancel: React.language("cancel"),
        //     ok: () => {
                
        //         return true;
        //     }
        // })
    }

    addAgainCorp = () => {
        let that = this;
        const {item} = this.state;
        React.axios('/corp/dock/corp/reinvite', {
            dock_corpid: [item.dock_corpid],
            label_id: item.label_id,
        }).then(res => {
            // const { target } = this.props;
            // target.parentNode.remove();
            tipAlert({
                type: 'success',
                msg: React.language('message.sended')
            })
            that.props.RefreshList();
        })
    }

    deepCopy = (obj, visited = new WeakMap()) => {
        // 如果 obj 是 null 或不是对象，直接返回它自身
        if (obj === null || typeof obj !== 'object') {
          return obj;
        }
      
        // 如果 obj 已经被访问过，返回它的副本以避免循环引用
        if (visited.has(obj)) {
          return visited.get(obj);
        }
      
        // 根据 obj 的类型创建一个新的空对象或数组
        let copy;
        if (Array.isArray(obj)) {
          copy = [];
        } else {
          copy = Object.create(Object.getPrototypeOf(obj));
        }
      
        // 记录访问过的 obj，以便处理循环引用
        visited.set(obj, copy);
      
        // 遍历 obj 的属性或数组元素并进行递归深拷贝
        for (let key in obj) {
          if (obj.hasOwnProperty(key)) {
            copy[key] = this.deepCopy(obj[key], visited);
          }
        }
      
        return copy;
    }

    getDomTreeContext=(context)=>{
        this.domTreeContext = context
    }

    getDeptList = () => {
        React.axios('/corp/department/list', {
        }).then(res => {
            this.setState({ departments: [...this.deepCopy(res.data.label_corp_list)], hasUserRole: 1, success: true })
            this.domTreeContext && this.domTreeContext.updataTree && this.domTreeContext.updataTree(this.deepCopy(res.data.label_corp_list));
        }).catch(res => {

        })
    }

    openContactTransfer = () =>{
        const { item } = this.state;
        const url = this.appendParameterToUrl(window.location.href.split("#")[0], 'dock_corpid', item.dock_corpid);
        window.open(url ? url : window.location.origin, "_blank");
    }

    appendParameterToUrl = (url, paramName, paramValue) => {
        const urlObj = new URL(url);
        const searchParams = urlObj.searchParams;
    
        if (searchParams.has(paramName)) {
            if (!paramValue) {
                searchParams.delete(paramName);
            } else {
                searchParams.set(paramName, paramValue);
            }
        } else {
            if (paramValue) {
                searchParams.append(paramName, paramValue);
            }
        }
    
        return urlObj.toString();
    }

    deptTreeNodeClick = (node) => {
        const { item, corpUserType } = this.state
        BsyAlertListDetail({
            type: "custom",
            width: 522,
            createContent:(e)=>{
                return <CorpDeptUserPane isdock={true} corpUserType={corpUserType} deptId={node.departmentId} dock_corpid={item.dock_corpid} name={node.name} newProps={e}></CorpDeptUserPane>
            }
        })
    }

    getDomTreeContext1=(context)=>{
        this.domTreeContext1 = context
    }

    getDeptList1 = () => {
        React.axios('/corp/department/list', {
        }).then(res => {
            this.setState({ departments: [...this.deepCopy(res.data.departments)], hasUserRole: 1, success: true })
            this.domTreeContext1 && this.domTreeContext1.updataTree && this.domTreeContext1.updataTree(this.deepCopy(res.data.departments));
        }).catch(res => {

        })
    }

    deptTreeNodeClick1 = (node) => {
        const { item, corpUserType } = this.state
        BsyAlertListDetail({
            type: "custom",
            width: 522,
            createContent:(e)=>{
                return <CorpDeptUserPane isdock={false} corpUserType={corpUserType} deptId={node.departmentId} dock_corpid={item.dock_corpid} name={node.name} newProps={e}></CorpDeptUserPane>
            }
        })
    }

    onRemoveNode = (e) =>{
        BsyAlert({
            title: React.language("contact.dock.dept.remove.title"),
            type: "warning",
            msg: React.language("contact.dock.dept.remove.tip"),
            text4Ok: React.language("ok"),
            OkType: "red",
            text4Cancel: React.language("cancel"),
            ok: () => {
                React.axios("/corp/dock/dept/delete",{corp_id: [e.dock_corpid], dept_id: [e.dept_id], type: "corp"}).then(res=>{
                    if(res.data.errcode !== 0){
                        tipAlert({
                            type: 'warning',
                            msg: res.data.errmessage
                        })
                        return
                    }
                    if(res.data.errcode === 0){
                        // let items = this.state.item;
                        // let corpUserData = this.state.item.dock_dept || [];
                        // let newUserList = [];
                        // corpUserData.map(res=>{
                        //     if(res.dept_id !== e.dept_id){
                        //         if(res.parentId === e.dept_id){
                        //             res.parentId = e.parentId;
                        //         }
                        //         newUserList.push({
                        //             ...res
                        //         })
                        //     }
                        // });
                        // items.dock_dept = newUserList;
                        // this.setState({item: items})
                        // this.domTreeContext && this.domTreeContext.updataTree && this.domTreeContext.updataTree(this.deepCopy(newUserList));
                        this.props.RefreshList(undefined, (s)=>{
                            let i;
                            s.map(r=>(
                                e.dock_corpid === r.dock_corpid && (i = r)
                            ))
                            i && this.setState({item: i},()=>{
                                this.domTreeContext && this.domTreeContext.updataTree && this.domTreeContext.updataTree(this.deepCopy(i.dock_dept));
                            })
                        });
                    }
                })
            }
        })
    }

    onRemoveNode1 = (e) =>{
        const { isOther } = this.state;
        BsyAlert({
            title: React.language("contact.dock.dept.remove.title"),
            type: "warning",
            msg: React.language("contact.dock.dept.remove.tip"),
            text4Ok: React.language("ok"),
            OkType: "red",
            text4Cancel: React.language("cancel"),
            ok: () => {
                React.axios("/corp/dock/dept/remove",{corp_id: [e.dock_corpid], dept_id: [e.dept_id], mode: isOther ? "guest" : "host"}).then(res=>{
                    if(res.data.errcode !== 0){
                        tipAlert({
                            type: 'warning',
                            msg: res.data.errmessage
                        })
                        return
                    }
                    if(res.data.errcode === 0){
                        // let items = this.state.item;
                        // let corpUserData = this.state.item.dept || [];
                        // let newUserList = [];
                        // corpUserData.map(res=>{
                        //     if(res.dept_id !== e.dept_id){
                        //         if(res.parentId === e.dept_id){
                        //             res.parentId = e.parentId;
                        //         }
                        //         newUserList.push({
                        //             ...res
                        //         })
                        //     }
                        // });
                        // items.dept = newUserList;
                        // this.setState({item: items})
                        // this.domTreeContext1 && this.domTreeContext1.updataTree && this.domTreeContext1.updataTree(this.deepCopy(newUserList));
                        this.props.RefreshList(undefined, (s)=>{
                            let i;
                            s.map(r=>(
                                e.dock_corpid === r.dock_corpid && (i = r)
                            ))
                            i && this.setState({item: i},()=>{
                                this.domTreeContext1 && this.domTreeContext1.updataTree && this.domTreeContext1.updataTree(this.deepCopy(i.dept));
                            })
                        });
                    }
                })
            }
        })
    }

    render() {
        const { item, nameWidth, corpCoopMap, contactMap, corpUserType, selectType, selectGroup, isOther } = this.state;
        let list = [{
            width: 110,
            key: "user",
            value: React.language("name"),
            title: true,//给元素添加title属性
            onCellCreate: (items, value) => {
                const bg = value ? value.name ? BsyUtils.formatUserThumb(value.name.toString()) : '' : '';
                return <ul className="user-list" title={value.name}>
                    <li className="user-item">
                        {value.avatarurl ? <img src={value.avatarurl} alt="" /> : <div className={`table-user-portrait-name color-${bg.color}`}><span>{bg.name}</span></div>}
                        <div className="user-name">{value.name}</div>
                    </li>
                </ul>
            },
        }, {
            width: 120,
            key: "mobile",
            value: React.language("phone"),
            onCellCreate: (items, value) => {
                return <>
                    <span title={value.mobile} className="text">{value.mobile }</span>
                    {value.mobile && value.mobilestatus == 0 && <div className="icon-cont">
                        <i className="icon-bsy-hint" onMouseEnter={(event) => {
                            window.FX.UI.showPopover({
                                position: "top",
                                anchor: window.$(event.target),
                                content: window.$("<span/>").text(React.language('contact.docker.phone.verify.tip',{productName:window._bby_config.site_name})),
                                type: "dark",
                            })
                        }} onMouseLeave={() => {
                            window.FX.UI.closePopover()
                        }}></i>
                    </div>}
                </>
                
            },
        }, {
            width: 140,
            key: "email",
            value: React.language("email"),
            onCellCreate: (items, value) => {
                return <>
                    <span title={value.email} className="text">{value.email }</span>
                    {value.email && value.emailstatus == 0 && <div className="icon-cont">
                        <i className="icon-bsy-hint" onMouseEnter={(event) => {
                            window.FX.UI.showPopover({
                                position: "top",
                                anchor: window.$(event.target),
                                content: window.$("<span/>").text(React.language('contact.docker.email.verify.tip',{productName:window._bby_config.site_name})),
                                type: "dark",
                            })
                        }} onMouseLeave={() => {
                            window.FX.UI.closePopover()
                        }}></i>
                    </div>}
                </>
            },
        }, {
            width: 120,
            key: "role_id",
            value: React.language("role"),
            onCellCreate: (items, value) => {
                if(!value.role_id){
                    return
                }
                let nameArray = value.role_id.map((val)=>{
                    if(contactMap[val]){
                        return contactMap[val].name
                    }
                })
                return  <ul className="user-list" title={nameArray.join(',')}>
                    {
                        value.role_id.map((val)=>{
                            if(contactMap[val]){
                                return <li className="user-item">
                                    <i className="icon-role"></i>
                                    <div className="user-name">{contactMap[val].name}</div>
                                </li>
                            }
                        })
                    }
                </ul>
            },
        }];
        if(!isOther){
            list.push({
                width: 100,
                key: "corp_status",
                onCellCreate: (items, value) => {
                    if(value.corp_status === 1 && (value.category === 2 || value.category === 0)){
                        return
                    }
                    let isGrey = "";
                    let hasTip = false;
                    if(value.corp_status === 0 && value.category === -1){
                        isGrey = " isGrey";
                        hasTip = true;
                    }
                    return <div className={"invite-btn" + isGrey} onClick={(event)=>{
                        event.stopPropagation();
                        event.preventDefault();
                        if(value.corp_status === 0 && value.category === -1){
                            return
                        }else if (value.corp_status === 0 && value.category === 0){
                            this.addAgainCorp();
                        }else if (value.corp_status === 1 && value.category === -1){
                            this.addAgainUser(value);
                        }
                    }} onMouseEnter={(event) => {
                        hasTip && window.FX.UI.showPopover({
                            position: "bottomLeft",
                            anchor: window.$(event.target),
                            content: window.$("<div style='width: 300px;' />").text(React.language('contact.handover.add.again.fail')),
                        })
                    }} onMouseLeave={() => {
                        hasTip && window.FX.UI.closePopover()
                    }}>
                       {React.language('contact.handover.add.again')}
                    </div>
                }
            })
        }
        let corpUserData = item.dock_user || [];
        let corpDeptData = item.dock_dept || [];
        let deptData = item.dept || [];
        if(corpUserType === "current"){
            corpUserData = item.user || [];
            list = [{
                width: 123,
                key: "user",
                value: React.language("name"),
                title: true,//给元素添加title属性
                onCellCreate: (items, value) => {
                    const bg = value ? value.name ? BsyUtils.formatUserThumb(value.name.toString()) : '' : '';
                    return <ul className="user-list" title={value.name}>
                        <li className="user-item">
                            {value.avatarurl ? <img src={value.avatarurl} alt="" /> : <div className={`table-user-portrait-name color-${bg.color}`}><span>{bg.name}</span></div>}
                            <div className="user-name">{value.name}</div>
                        </li>
                    </ul>
                },
            }, {
                width: 130,
                key: "mobile",
                value: React.language("phone"),
                onCellCreate: (items, value) => {
                    return <>
                        <span title={value.mobile} className="text">{value.mobile }</span>
                        {value.mobile && value.mobilestatus == 0 && <div className="icon-cont">
                            <i className="icon-bsy-hint" onMouseEnter={(event) => {
                                window.FX.UI.showPopover({
                                    position: "top",
                                    anchor: window.$(event.target),
                                    content: window.$("<span/>").text(React.language('contact.docker.phone.verify.tip',{productName:window._bby_config.site_name})),
                                    type: "dark",
                                })
                            }} onMouseLeave={() => {
                                window.FX.UI.closePopover()
                            }}></i>
                        </div>}
                    </>
                    
                },
            }, {
                width: 154,
                key: "email",
                value: React.language("email"),
                onCellCreate: (items, value) => {
                    return <>
                        <span title={value.email} className="text">{value.email }</span>
                        {value.email && value.emailstatus == 0 && <div className="icon-cont">
                            <i className="icon-bsy-hint" onMouseEnter={(event) => {
                                window.FX.UI.showPopover({
                                    position: "top",
                                    anchor: window.$(event.target),
                                    content: window.$("<span/>").text(React.language('contact.docker.email.verify.tip',{productName:window._bby_config.site_name})),
                                    type: "dark",
                                })
                            }} onMouseLeave={() => {
                                window.FX.UI.closePopover()
                            }}></i>
                        </div>}
                    </>
                },
            },{
                width: 53,
                key: "",
                value: "",
            },{
                width: 100,
                key: "removeout",
                value: "",
            }];
        }
        let isInvite = false;
        let inviteNum = 0;
        corpUserData.map(res=>{
            if(res.category === -1){
                isInvite = true;
                inviteNum++
            }
        })
        return (
            <div className="CorpCoopDeatilsPane">
                <div className="header-name">
                    {!isOther ? <div className="nameTitle">
                        <div className="name-input">
                            <input type="text" maxLength={32} style={{width: nameWidth}} value={item.dock_corpname} onChange={this.changeDockCorpName} onBlur={this.blurDockCorpName} onMouseEnter={(event) => {
                                window.FX.UI.showPopover({
                                    position: "bottomLeft",
                                    anchor: window.$(event.target),
                                    content: window.$("<span/>").text(React.language('rename')),
                                    type: "dark",
                                    edge: 15
                                })
                            }} onMouseLeave={() => {
                                window.FX.UI.closePopover()
                            }} />
                            {
                                item.is_tmp_owner && <div className="is_tmp_owner_tip">
                                    {React.language('contact.escrow')}
                                </div>
                            }
                        </div>
                        <span ref={this.nameWidthEl} onChange={this.changeNameTitileWidth}>{item.dock_corpname}</span>
                    </div> : <div className="nameTitle">
                        {item.owner_corpname}
                    </div>}
                    <div className="create-user">
                        <div className="label-title">{React.language('manager.creator') + "："}</div>
                        <div className="cont-text">{item.create_user ? item.create_user.name : ""}</div>
                    </div>
                    <div className="closePane" onClick={this.closeAlert}>
                        <i className="icon-close-large"></i>
                    </div>
                </div>
                <div className="body-deatils">
                    {!isOther && <div className="corpCoopLabel">
                        <div className="label-title">
                            {React.language('persona.corp.dept.label')}
                        </div>
                        <div className="label-list">
                            <div className="label-content" onClick={this.openLabelPane}>
                                {corpCoopMap[item.label_id] ? <div className="label-item">
                                    <i className='icon-corp-label'></i>
                                    <span>{corpCoopMap[item.label_id].name}</span>
                                </div> : <div className='label-empty'>
                                    {React.language('label.select')}
                                </div>}
                            </div>
                        </div>
                    </div>}
                    <div className="dock-user-pane">
                        <div className="pane-tab-add">
                            <div className="pane-tab">
                                <div className={"tab-item" + (corpUserType === "other" ? " active" : "")} onClick={this.dockSwitch("other")}>{React.language('contact.handover.other')}</div>
                                <div className={"tab-item" + (corpUserType === "otherDept" ? " active" : "")} onClick={this.dockSwitch("otherDept")}>{React.language('contact.handover.other.dept')}</div>
                                <div className={"tab-item" + (corpUserType === "current" ? " active" : "")} onClick={this.dockSwitch("current")}>{React.language('contact.handover.current')}</div>
                                <div className={"tab-item" + (corpUserType === "currentDept" ? " active" : "")} onClick={this.dockSwitch("currentDept")}>{React.language('contact.handover.current.dept')}</div>
                            </div>
                            {!(isOther && (corpUserType === "other" || corpUserType === "otherDept")) && <div className="pane-add">
                                <div className={"add-btn" + ((!item.is_tmp_owner && (corpUserType === "other" || corpUserType === "otherDept")) ? " ban" : "")} onClick={this.openAddPane} onMouseEnter={(event) => {
                                    this.hoverAddPanel(event)
                                }}>
                                    <i className="icon-add"></i>
                                    <span>{React.language("add")}</span>
                                </div>
                            </div>}
                        </div>

                        {(corpUserType === "other" || corpUserType === "current") && !isOther && (item.category === -1 ? <div className="pane-invite-all">
                            <div className="invite-cont">
                                <div className="invite-num">
                                    {React.language('contact.corp.not.connection.single')}
                                </div>
                                <div className="invite-btn" onClick={this.addAgainCorp}>
                                    {React.language('member.invite.again')}
                                </div>
                            </div>
                        </div> : isInvite && <div className="pane-invite-all">
                            <div className="invite-cont">
                                <div className="invite-num">
                                    {React.language('contact.handover.not.join.tip',{count: inviteNum})}
                                </div>
                                <div className="invite-btn" onClick={this.addAgainAllUser}>
                                    {React.language('contact.handover.add.all.again')}
                                </div>
                            </div>
                        </div>)}
                        <div className="pane-cotnent">
                            {
                                ((corpUserType === "otherDept" || corpUserType === "currentDept") && !((corpUserType === "currentDept" && deptData.length <= 0) || (corpUserType === "otherDept" && corpDeptData.length <= 0) || ((corpUserType === "other" || corpUserType === "current") && corpUserData.length <= 0))) && <div className="pane-dept-title">
                                    {React.language('department')}
                                </div>
                            }
                            {(corpUserType === "other" || corpUserType === "current") && corpUserData.length > 0 && <BsyTableList
                                getValue={this.getTableValue}
                                key={new Date().getTime()}
                                noDarg={true}
                                multiple={false}
                                hasTurnPage={false}
                                noMenu={corpUserType === "current" || isOther}
                                styleType={window.mode}
                                userCont={{
                                    users: corpUserData || []
                                }}
                                list={list}
                                onRowOrder={e => { !isOther && this.handleUserOrder(e) }}
                                onReinvite={e => { !isOther && this.againAllInvite(e) }}
                                onRowClick={(e, node) => {this.memberRowClick(e, node) }}
                            />}
                            {corpUserType === "otherDept" && corpDeptData.length > 0 && <div className='teamTree'>
                                <BsyDomTree menuItem={isOther ? ["detail"] : ["del", "detail"]} onRemoveNode={(e)=>{this.onRemoveNode(e)}} reClick={true} departments={this.deepCopy(corpDeptData)} domTreeContext={this.getDomTreeContext} getDeptList={this.getDeptList} selectDept={null} selectKey={null} nodeClick={(node) => this.deptTreeNodeClick(node)} />
                            </div>}
                            {corpUserType === "currentDept" && deptData.length > 0 && <div className='teamTree'>
                                <BsyDomTree menuItem={isOther ? ["detail"] : ["del", "detail"]} onRemoveNode={(e)=>{this.onRemoveNode1(e)}} reClick={true} departments={this.deepCopy(deptData)} domTreeContext={this.getDomTreeContext1} getDeptList={this.getDeptList1} selectDept={null} selectKey={null} nodeClick={(node) => this.deptTreeNodeClick1(node)} />
                            </div>}
                            {
                                ((corpUserType === "currentDept" && deptData.length <= 0) || (corpUserType === "otherDept" && corpDeptData.length <= 0) || ((corpUserType === "other" || corpUserType === "current") && corpUserData.length <= 0)) && <div className="dock-empty">
                                    <img src={emptyDockUser} alt="" />
                                    <div className="dock-empty-tip">{(corpUserType === "other" || corpUserType === "current") ? React.language('contact.docker.empty') : React.language('contact.docker.dept.empty')}</div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
                <div className="footer-pane">
                    {
                        item.is_tmp_owner && !isOther && <div style={{"margin-right": "12px"}} className="pane-btn bule" onClick={this.openContactTransfer}>
                            {React.language('open.contact.manage.transfer')}
                        </div>
                    }
                    {
                        item.is_tmp_owner && !isOther && <div style={{"margin-right": "12px"}} className="pane-btn bule" onClick={this.openAuthTransfer}>
                            {React.language('contact.manage.auth.transfer')}
                        </div>
                    }
                    {
                        isOther && item.is_guest_corp && <div style={{"margin-right": "12px"}} className="pane-btn bule" onClick={this.openDockCorpInvite}>
                            {React.language('contact.connect.host.corp')}
                        </div>
                    }
                    {
                        <div className="pane-btn red" style={{"margin-right": "12px"}} onClick={this.removeContact}>
                            {selectGroup === "corpCoopAll" ? React.language('contact.connection.remove') : React.language('remove.out')}
                        </div>
                    }
                    {
                      !item.is_tmp_owner && item.common && <div className="pane-btn bule" onClick={()=>{
                          React.axios("/corp/apply_owner",{dock_corpid: item.dock_corpid}).then(res=>{
                              if(res.data.errcode !== 0){
                                  tipAlert({
                                      type: "warning",
                                      msg: res.data.errmessage
                                  })
                                  return;
                              }
                              tipAlert({
                                  type: "success",
                                  msg: React.language('contact.manage.auth.request.success')
                              })
                          })
                      }}>
                          {React.language("contact.manage.auth.request")}
                      </div>
                    }
                </div>
            </div>
        )
    }
}

export default CorpCoopDeatilsPane